import React from 'react';
import { Box } from '@mui/material';
import logo from 'assets/images/app_logo.png';

const LogoIcon = () => {
  return (
    <Box sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center', width: '100%', py: 0.5 }}>
      <img
        src={logo}
        alt="App Logo Icon"
        style={{
          maxHeight: '36px',
          maxWidth: '36px',
          objectFit: 'contain',
          display: 'block',
          margin: '0 auto'
        }}
      />
    </Box>
  );
};

export default LogoIcon;
